let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("36M5Z")).then(() => parcelRequire('5kAX9'));